package app.bloomey.web.core.data.models

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val firstName: String,
    val lastName: String,
    val email: String,
    val createdAt: Long,
    val blackListed: Boolean,
)

@Serializable
data class UpdateUserRequest(
    val firstName: String,
    val lastName: String,
    val blackListed: Boolean,
)
